module.exports = __webpack_public_path__ + "img/turkey.7386a790.svg";